import React, { useState, memo } from 'react';
import { ChevronDownIcon, BookOpenIcon } from 'lucide-react';
import { BuyButton } from './BuyButton';
interface Module {
  emoji: string;
  title: string;
  subtitle: string;
  pages: string;
  items: {
    icon: string;
    text: string;
  }[];
}
const modules: Module[] = [{
  emoji: '📖',
  title: 'CAPÍTULO 1 — Farmacología Sin Pánico',
  subtitle: 'Dosis, Fármacos y Protocolos que Vas a Usar de Verdad',
  pages: '~60 páginas',
  items: [{
    icon: '💊',
    text: 'Las 20 moléculas que todo estudiante debe conocer de memoria'
  }, {
    icon: '🐕🐈',
    text: 'Diferencias clave perro vs. gato (lo que te puede matar en el examen y en la clínica)'
  }, {
    icon: '⚖️',
    text: 'Cómo calcular dosis sin equivocarte bajo presión'
  }, {
    icon: '🚫',
    text: 'Interacciones medicamentosas más comunes y peligrosas'
  }, {
    icon: '📋',
    text: 'Tabla resumen descargable: fármacos x especie x dosis x vía de administración'
  }, {
    icon: '🧠',
    text: 'Truco mnemotécnico para recordar antibióticos, AINEs y anestésicos'
  }]
}, {
  emoji: '🩺',
  title: 'CAPÍTULO 2 — El Examen Físico Perfecto',
  subtitle: 'Del Animal Real al Diagnóstico Presuntivo',
  pages: '~60 páginas',
  items: [{
    icon: '👁️',
    text: 'Orden sistemático del examen físico que nunca falla'
  }, {
    icon: '📝',
    text: 'Checklist descargable para anamnesis completa'
  }, {
    icon: '❤️',
    text: 'Cómo interpretar frecuencia cardíaca, respiratoria y temperatura por especie'
  }, {
    icon: '🔴',
    text: 'Señales de alarma que no podés ignorar en consulta'
  }, {
    icon: '🎯',
    text: 'Del signo clínico al diagnóstico diferencial: cómo pensar como clínico'
  }, {
    icon: '📸',
    text: 'Guía visual de hallazgos normales vs. patológicos'
  }]
}, {
  emoji: '🚨',
  title: 'CAPÍTULO 3 — Emergencias y Primeros Auxilios',
  subtitle: 'Protocolo Paso a Paso',
  pages: '~60 páginas',
  items: [{
    icon: '⏱️',
    text: 'Los primeros 5 minutos: qué hacer cuando llega un paciente crítico'
  }, {
    icon: '🫀',
    text: 'RCP veterinario actualizado (técnica, ritmo, fármacos de emergencia)'
  }, {
    icon: '🐍',
    text: 'Intoxicaciones más frecuentes en perros y gatos: qué hacer y qué NO hacer'
  }, {
    icon: '🩸',
    text: 'Manejo del shock: tipos, diagnóstico rápido y tratamiento inicial'
  }, {
    icon: '🌡️',
    text: 'Golpe de calor, hipotermia y convulsiones: acción inmediata'
  }, {
    icon: '📋',
    text: 'Tarjeta de bolsillo de emergencias (formato imprimible)'
  }]
}, {
  emoji: '🔬',
  title: 'CAPÍTULO 4 — Laboratorio Clínico para Estudiantes',
  subtitle: 'Interpretá los Resultados como un Pro',
  pages: '~60 páginas',
  items: [{
    icon: '🧪',
    text: 'Hemograma completo: qué te dice cada valor y cuándo preocuparte'
  }, {
    icon: '💧',
    text: 'Bioquímica sanguínea básica: hígado, riñón y páncreas en números'
  }, {
    icon: '🔍',
    text: 'Sedimento urinario: guía visual para no confundir nada'
  }, {
    icon: '📊',
    text: 'Cómo leer un resultado de laboratorio con criterio clínico'
  }, {
    icon: '⚡',
    text: 'Errores más comunes al tomar e interpretar muestras'
  }, {
    icon: '🗂️',
    text: 'Valores de referencia por especie en tabla comparativa'
  }]
}, {
  emoji: '🐾',
  title: 'CAPÍTULO 5 — Atlas Visual de Razas y Enfermedades Prevalentes',
  subtitle: '',
  pages: '~60 páginas',
  items: [{
    icon: '🐶',
    text: 'Razas de alto riesgo y sus enfermedades predisponentes más comunes'
  }, {
    icon: '🐱',
    text: 'Enfermedades infecciosas felinas que todo estudiante debe dominar'
  }, {
    icon: '🐇🐹',
    text: 'Introducción a especies no convencionales: signos clínicos básicos'
  }, {
    icon: '🌍',
    text: 'Enfermedades prevalentes en Argentina y Latinoamérica (Chagas, Leishmaniasis, Ehrlichia, Parvovirus)'
  }, {
    icon: '🗺️',
    text: 'Mapa de enfermedades por región geográfica'
  }, {
    icon: '📷',
    text: 'Imágenes clínicas comentadas de presentaciones típicas'
  }]
}, {
  emoji: '🎓',
  title: 'CAPÍTULO 6 — Del Aula a la Clínica',
  subtitle: 'Cómo Sobrevivir (y Brillar) en tus Primeras Prácticas',
  pages: '~60 páginas',
  items: [{
    icon: '😰',
    text: 'El síndrome del estudiante en clínica: cómo manejar el miedo a equivocarte'
  }, {
    icon: '🗣️',
    text: 'Cómo comunicarte con el profesional a cargo sin quedar mal'
  }, {
    icon: '👐',
    text: 'Técnicas de contención y manejo del paciente sin lastimarte ni lastimarlo'
  }, {
    icon: '💉',
    text: 'Vías de administración: IV, IM, SC, IO — técnica correcta ilustrada'
  }, {
    icon: '📓',
    text: 'Cómo escribir una historia clínica que te haga ver profesional'
  }, {
    icon: '🤝',
    text: 'Cómo tratar al dueño de la mascota: lenguaje, empatía y límites'
  }]
}];
export function Modules() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="w-full py-16 px-4 bg-white" data-id="element-162">
      <div className="max-w-4xl mx-auto" data-id="element-163">
        <div className="text-center mb-10" data-id="element-164">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-slate-900" data-id="element-165">
            Carrera Veterinaria 360 fue diseñado para resolver eso.
          </h2>
          <p className="mt-3 text-slate-600 max-w-2xl mx-auto" data-id="element-166">
            6 capítulos que conectan la teoría que ves en la facultad con lo que
            vas a hacer realmente en la clínica.
          </p>
        </div>

        <div className="space-y-3" data-id="element-167">
          {modules.map((m, i) => {
          const isOpen = openIdx === i;
          return <div key={i} className={`rounded-xl border-2 overflow-hidden transition-all duration-300 ${isOpen ? 'bg-green-600 border-green-700 text-white shadow-xl shadow-green-200' : 'bg-white border-slate-200 hover:border-green-300'}`} data-id="element-168">
                <button onClick={() => setOpenIdx(isOpen ? null : i)} className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left" data-id="element-169">
                  <div className="flex items-start gap-3 flex-1" data-id="element-170">
                    <span className="text-2xl" data-id="element-171">{m.emoji}</span>
                    <div data-id="element-172">
                      <h3 className={`font-extrabold text-base sm:text-lg leading-tight ${isOpen ? 'text-white' : 'text-slate-900'}`} data-id="element-173">
                        {m.title}
                      </h3>
                      {m.subtitle && <p className={`text-sm mt-0.5 ${isOpen ? 'text-green-50' : 'text-slate-600'}`} data-id="element-174">
                          {m.subtitle}
                        </p>}
                      <span className={`inline-block mt-1 text-xs font-semibold ${isOpen ? 'text-green-100' : 'text-green-700'}`} data-id="element-175">
                        {m.pages}
                      </span>
                    </div>
                  </div>
                  <ChevronDownIcon className={`w-6 h-6 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-white' : 'text-slate-400'}`} data-id="element-176" />
                </button>

                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-177">
                  <div className="overflow-hidden" data-id="element-178">
                    <ul className="px-5 pb-5 pt-0 space-y-2.5 border-t border-green-500/30" data-id="element-179">
                      {m.items.map((item, j) => <li key={j} className="flex items-start gap-3 pt-2.5" data-id="element-180">
                          <span className="text-lg flex-shrink-0" data-id="element-181">
                            {item.icon}
                          </span>
                          <span className="text-sm sm:text-base text-white/95 leading-snug" data-id="element-182">
                            {item.text}
                          </span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}